/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Csv_Change_Type_ModifiedInputs */

const en_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modified`)
};

const fr_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modifié`)
};

const de_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modifiziert`)
};

const it_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modificato`)
};

const ru_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`модифицированный`)
};

const es_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modificado`)
};

const zh_cn2_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改的`)
};

const ja_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更された`)
};

const hi_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संशोधित`)
};

const pt_pt2_compare_event_groups_csv_change_type_modified = /** @type {(inputs: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modificado`)
};

/**
* | output |
* | --- |
* | "modified" |
*
* @param {Compare_Event_Groups_Csv_Change_Type_ModifiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_csv_change_type_modified = /** @type {((inputs?: Compare_Event_Groups_Csv_Change_Type_ModifiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Csv_Change_Type_ModifiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_csv_change_type_modified(inputs)
	if (locale === "de") return de_compare_event_groups_csv_change_type_modified(inputs)
	if (locale === "it") return it_compare_event_groups_csv_change_type_modified(inputs)
	if (locale === "ru") return ru_compare_event_groups_csv_change_type_modified(inputs)
	if (locale === "es") return es_compare_event_groups_csv_change_type_modified(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_csv_change_type_modified(inputs)
	if (locale === "ja") return ja_compare_event_groups_csv_change_type_modified(inputs)
	if (locale === "hi") return hi_compare_event_groups_csv_change_type_modified(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_csv_change_type_modified(inputs)
	return en_compare_event_groups_csv_change_type_modified(inputs)
});